import l10n from '../../../shared/strings';

export const countAttachTargetRecords = (targets = {}) => {
  let products = 0;
  let variants = targets.masterVariantIds?.length || 0;

  if (targets.masterGallery) {
    products += 1;
  }

  (targets.listings || []).forEach((listing) => {
    if (listing.listingGallery) {
      products += 1;
    }
    variants += listing.listingVariantIds?.length || 0;
  });

  return { products, variants };
};

export const showMediaAddedToast = (Toast, { products = 0, variants = 0 } = {}) => {
  const message = l10n.TOAST.MEDIA_ADDED_TO_PRODUCTS(products, variants);
  if (!message || !Toast) return;
  Toast(message, { type: 'success' });
};

export const showMediaAddFailedToast = (Toast) => {
  if (!Toast) return;
  Toast(l10n.TOAST.MEDIA_ADD_FAILED, { type: 'error' });
};
